/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const NonTraditionalResearch = ({
    nonTraditionalResearchProjectName,
    nonTraditionalResearchExpectedOutput,
}: Partial<{
    nonTraditionalResearchProjectName: string;
    nonTraditionalResearchExpectedOutput: string;
}>) => (
    <>
        <Row>
            <ValueCell single label="Project Name" value={nonTraditionalResearchProjectName} />
        </Row>
        <Row>
            <ValueCell label="Expected Output" value={nonTraditionalResearchExpectedOutput} />
        </Row>
    </>
);

export default NonTraditionalResearch;
